import Cookies from 'js-cookie'

/**
 * 鉴权字段名
 * @constant
 * @default
 * @type {string}
 */
const tokenKey = 'userToken'

/**
 * 获取token
 * @returns {string} - 鉴权token
 */
const getToken = () => Cookies.get(tokenKey)

/**
 *  设置token
 *  @param {string} token - 后端返回的鉴权成功值
 */
const setToken = (token) => Cookies.set(tokenKey, token)

/** 删除token */
const removeToken = () => Cookies.remove(tokenKey)

export { getToken, setToken, removeToken, Cookies }
